import {getApiErrorMessage} from '../../utils/apiError';

/**
 * The server's own words for a failed catalog call, or a fallback.
 *
 * Now a thin alias: the logic moved to `utils/apiError.getApiErrorMessage` when the measurement
 * screens needed exactly the same unwrapping to surface the formula lock's 409. This name is kept
 * because the food-dictionary call sites read well with it, and because it is the file the test for
 * this behaviour already lives beside.
 */
export const foodDictionaryErrorMessage = (error: unknown, fallback: string): string =>
  getApiErrorMessage(error, fallback);
